import React from 'react';
import { useTranslation } from 'react-i18next';

const DownloadApp = () => {
  const { t } = useTranslation(['checkout']);

  return (
    <div className="w-full flex justify-center md:max-w-[291px] max-w-[450px]">
      <div className="rounded-2xl border border-[#EBEBEB] relative overflow-hidden w-full">
        <div className="block mt-4 mb-10 cursor-pointer mx-auto z-10 relative">
          <div className="">
            <div className="flex flex-col items-center gap-2 max-w-[197px] mx-auto text-center text-[#202020]">
              <img
                src="/img/qr/mobile-app-download.svg"
                className="h-[161px] mb-4 shadow-lg shadow-primary-50 rounded-2xl overflow-hidden hidden md:block"
              />
              <p className="font-semibold text-xl tracking-[0.02em] max-w-[160px]">
                {t('checkout:accessYourTicketsOnTheGo')}
              </p>
              <p className="text-base font-normal">
                {t('checkout:downloadTheAppForEasyCheckInAndEventUpdates')}
              </p>
            </div>
            <div className="mt-5 flex items-center justify-center gap-3">
              <a href="https://bouncelife.com/ios">
                <img
                  src="/img/app-store-black-small.png"
                  alt="App Store"
                  className="h-[34.94px]"
                />
              </a>
              <a href="https://bouncelife.com/android">
                <img
                  src="/img/play-store-black-small.png"
                  alt="Play Store"
                  className="h-[34.94px]"
                />
              </a>
            </div>
          </div>
        </div>
        <div
          className="absolute bottom-0 left-0 right-0 h-20 z-0 pointer-events-none opacity-100"
          style={{
            background:
              'radial-gradient(ellipse at bottom center, #B5E2FB 0%, white 80%)'
          }}
        />
      </div>
    </div>
  );
};

export default DownloadApp;
